import Vue from 'vue';
import Vuex from 'vuex';
import cookieparser from 'cookieparser';
cookieparser.maxLength = 18196;

import lead from './modules/lead';
import modal from './modules/modal';
import submenu from './modules/submenu';
import exam from './modules/exam';

Vue.use(Vuex);

const store = () => new Vuex.Store({
  state: {
    jwtToken: null,
    dataLayer: {},
    models: {}
  },
  modules: {
    exam,
    lead,
    modal,
    submenu,
  },
  mutations: {
    SET_TOKEN: function (state, token) {
      state.jwtToken = token;
    },

    SET_MODEL_DATA: function(state, { model, data }) {
      state.models[model] = data;
    },

    DATA_LAYER_PUSH: function(state, data) {
      state.dataLayer = Object.assign(state.dataLayer, data);
    }
  },
  actions: {
    nuxtServerInit ({ commit }, { req }) {
      if (req) {
        let jwtToken = null;
        if (req.headers.cookie) {
          const parsed = cookieparser.parse(req.headers.cookie);

          jwtToken = parsed.jwtToken;
        }
        commit('SET_TOKEN', jwtToken);
      }
    },
  },
});

export default store;
